import {
  FilterType,
  buildPerformanceReviewsDataTableFilter,
  usePerformanceReviewsDataTable,
} from 'generated/resources/datatable.graphql'
import { PerformanceProcessReviewsDataTableCycleFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const cycleFilter = (
  source: ReturnType<typeof usePerformanceReviewsDataTable>,
  options: PerformanceProcessReviewsDataTableCycleFragment[]
) => {
  return buildPerformanceReviewsDataTableFilter(source, {
    type: FilterType.String,
    default: true,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: options.map((cycle) => ({ label: cycle.title, value: cycle.id })),
      },
    ],
    identifier: 'cycleIdFilter',
    path: 'cycleId',
    title: i18n.t('performance_process.reviews.datatable.cycle'),
  })
}
